import React from "react";
import { components } from "react-select";
import { Spinner } from "../../spinner";

/**
 * @deprecated This component is being removed in V6+, February 2025, in favor of the `SelectV2/MultiSelectV2` components.
 */
export const LoadingIndicator: typeof components.LoadingIndicator = (props) => (
    <div style={props.getStyles("loadingIndicator", props)} {...props.innerProps}>
        <Spinner size="small" />
    </div>
);
